import { ApiError, type ProblemDetails } from './ApiError'

const BASE_URL = '/api'

export interface ApiFetchInit extends Omit<RequestInit, 'headers'> {
  token: string
  headers?: Record<string, string>
}

export async function apiFetch<T>(path: string, init: ApiFetchInit): Promise<T> {
  const { token, headers, ...rest } = init
  const res = await fetch(`${BASE_URL}${path}`, {
    ...rest,
    headers: {
      ...headers,
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  })
  if (!res.ok) {
    let problem: ProblemDetails = {}
    try {
      problem = await res.json()
    } catch {
      // A non-JSON error body (an LB 502 HTML page, say) carries nothing worth
      // showing; the status alone drives every decision the caller makes.
    }
    throw new ApiError(res.status, problem)
  }
  if (res.status === 204) return undefined as T
  return res.json() as Promise<T>
}
